import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { getChangeMonitoringErrorMessage } from '@api/manageNetworkElementConfigurations';

import { IWithUpdateId } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';

import { EUserRoles } from '@enums/common';

import { NETWORK_ELEMENT_CHANGE_MONITORING_ERROR_MESSAGE } from '@constants/queryKeys';

interface IUseMutateChangeMonitoringErrorMessageReturned {
	isLoadingChangeMonitoringErrorMessage: boolean;
	getErrorMessage: UseMutateFunction<any, any, IWithUpdateId, any>;
	errorMessage: string;
}

const useMutateChangeMonitoringErrorMessage = (): IUseMutateChangeMonitoringErrorMessageReturned => {
	const {
		isLoading,
		mutate,
		data,
	} = useMutation<IWithUpdateId>({
		mutationKey: [NETWORK_ELEMENT_CHANGE_MONITORING_ERROR_MESSAGE],
		mutationFn: getChangeMonitoringErrorMessage,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		errorMessage: data?.rawData,
		isLoadingChangeMonitoringErrorMessage: isLoading,
		getErrorMessage: mutate,
	};
};

export default useMutateChangeMonitoringErrorMessage;
